export default __webpack_public_path__ + "static/feature9-7e45e62f31a0e1f8821ec908bbad85b6.webp";